import Svg, { Path } from '@rd-core-svg/svg'
import type { LogoSvgProps } from '../svg.types'

export const UniversBlackSymbol = (props: LogoSvgProps) => {
  return (
    <Svg {...props} viewBox="0 0 56 80" fill="none">
      <Path
        d="M31.9299 12.6375C30.8692 11.5034 29.5539 11.9741 29.6175 13.3758L30.4131 27.4456C30.7419 33.8439 34.3801 37.578 40.7231 37.9096L54.6713 38.7121C56.0608 38.7763 56.4533 37.5138 55.4032 36.3796L31.9299 12.6375Z"
        fill="#000"
      />
      <Path
        d="M54.6607 41.3014L40.7231 42.0932C34.3801 42.4248 30.7419 46.1589 30.4131 52.5572L29.6175 66.627C29.5539 68.0287 30.8692 68.4887 31.9299 67.3653L55.3926 43.6339C56.4426 42.4997 56.0502 41.2265 54.6607 41.3014Z"
        fill="#000"
      />
      <Path
        d="M25.5869 52.5679C25.2581 46.1696 21.6199 42.4355 15.2769 42.1038L1.32871 41.3014C-0.0608042 41.2372 -0.453262 42.5639 0.596831 43.6338L24.0701 67.3653C25.1308 68.4994 26.4461 68.0286 26.3825 66.627L25.5869 52.5679Z"
        fill="#000"
      />
      <Path
        d="M24.0705 12.6383L0.607842 36.3697C-0.452858 37.4396 -0.0497898 38.7664 1.33973 38.7022L15.2879 37.8997C21.6309 37.568 25.2691 33.8339 25.5979 27.4356L26.3935 13.3658C26.4465 11.9642 25.1206 11.5041 24.0705 12.6383Z"
        fill="#000"
      />
    </Svg>
  )
}
